import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Divider
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";
import { ContextData } from "../../../../../../../context/Context";
import { Getrequest } from "../../../../../../../context/AxiosRequest";
import { toast } from "react-toastify";
import SoundAlert from "../../../../../../../routes/SoundAlert";

// 📌 Dynamic Variables (you can load this from API later)


function formatNumber(value) {
    if (value === "" || value == null) return "";
    // value is raw digits string (no decimals). Convert to number then format.
    const num = Number(value);
    if (Number.isNaN(num)) return "";
    return new Intl.NumberFormat().format(num);
}



export default function InPrincipleOfferThirdParty({from,data,user_token,program_type}) {

  const handlePrint = () => {
    window.print();
    
  };

  

  const [checkDisburs,setcheckDisburs] = useState("yet")
  const Navigate = useNavigate();
  const {accesstoken,UserTokens} = useContext(ContextData)
   const [ChangeLoanForm, setChangeLoanForm] = useState(null);
   const [disbursementData, setDisbursementData] = useState(null);

   // loanEv

   const [GetOffer,setGetOffer] = useState(null)

      useEffect(()=>{
    
    
            (async()=>{
    
                     const response = await Getrequest(`/auth/get_inpriciple_offer/${ from === "loanEv" ? user_token  : UserTokens}`,accesstoken)
                     
                     const loanData = await Getrequest(`/auth/get_loan_data/${ from === "loanEv" ? user_token  : UserTokens}`,accesstoken)
                       
                     


                        

                        if(from !== "loanEv"){
                       
                          const responseDisburs = await Getrequest(`/auth/get_disbursement_request/${UserTokens}`,accesstoken)
                          const get_disburs = await Getrequest(`/auth/get_disbursement_request/${UserTokens}`,accesstoken)

                              if(get_disburs?.data){
        
                                   
                                   
                                         
                                         setcheckDisburs(get_disburs?.data.accept_request)

                                        // console.log(get_disburs?.data.accept_request)
              
                                  }

                            
                                               if(responseDisburs.status){


                                                    setDisbursementData(responseDisburs)


                                                 }else{


                                                   setDisbursementData(responseDisburs.status)


                                                 }









                                 }

                  /*   const response = await Getrequest(`/auth/get_inpriciple_offer/${UserTokens}`,accesstoken)
                    const loanData = await Getrequest(`/auth/get_loan_data/${UserTokens}`,accesstoken) */
     
    
                            setGetOffer([response])   
                            if(loanData) setChangeLoanForm(loanData?.loanrequest[0]?.loan_category)
                          
    
            })()  
    
    
             
        },[])
    


    const HandleNavigate = (guarantor, amountOffered) => {

            
      

             // thirdparty

       if(ChangeLoanForm === "thirdparty"){
        
        Navigate(`/application/offers/utilization_letter_thirt_party/${guarantor}/${amountOffered}`)

       } else{
         
         Navigate("/application/offers/utilization_letter_student")
       }

    }


     if(GetOffer !== null){

        if(GetOffer[0].Sponsor == undefined && from !== "loanEv" ){
    
                        Navigate("/application/my_application_details")
                        toast.warn("Letter not found")
                        SoundAlert("error")
                        return
         }


      }
    




  return (
    <Box
      id="print-area"
      sx={{
        p: 3,
        maxWidth: "900px",
        mx: "auto",
        background:"white"
      }} 
    >


   <div className="w-full flex justify-between  mb-4">
 
              {/* PRINT BUTTON */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mb: 2,
          "@media print": { display: "none" },
        }}
      >

       {
        from !== "loanEv" &&
        <IconButton color="primary" onClick={handlePrint}>
          <PrintIcon />
        </IconButton>
       }
          



      </Box>


          {
            from !== "loanEv"  &&
            <>
             {
              disbursementData === null &&

          <button
          style={{
            backgroundColor: "#d32f2f",
            border: "none",
            padding: "12px",
            color: "white",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: "pointer",
            width: "20%",
            
          }}
          className="d-btn"
          onClick={() => prompt("Are you sure you want to decline this offer?")}
        >
           
          Decline Offer
        </button>

             }
            </>
      
          }

        </div>
     
      {/* HEADER */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
        
                            <img src="/newksslb.jpg" alt="KSSLB Logo" style={{ width: '100px', height: '100px', display: 'block', margin: '0 auto'  }} />
        
                            <div className="mt-3">
        
                           <Typography sx={{ lineHeight: 1.9,fontFamily:"monospace",textAlign:"center" }} variant="h5" fontWeight="bold" gutterBottom>
                          KADUNA STATE SCHOLARSHIP AND LOANS BOARD
                         </Typography>   
                         
                         <Typography sx={{ lineHeight: 0.8,fontFamily:"monospace",textAlign:"center" }}  fontWeight="bold" gutterBottom>
                          STUDENT TERTIARY EDUCATION LOAN (Third Party)
                         </Typography>  
                         <Typography sx={{ lineHeight: 1.9,fontFamily:"monospace",textAlign:"center" }}  fontWeight="bold" gutterBottom>
                         LOAN APPLICATION  IN-PRINCIPLE (OFFER LETTER)
                         </Typography>
                           {from === "loanEv"  &&  <p className="text-center capitalize bg-green-950 text-white">{program_type}</p> }
                              
                            </div>
                         </div>
               
             <Divider  sx={{ my: 3 }} />
         {
            from === "loanEv" && 

              <Box sx={{ mb: 4 }}>
          <div>

          <Typography variant="body1" sx={{ lineHeight: 1.9,fontFamily:"monospace" }}>
            Dear <strong>{data.Sponsor}</strong>,
            <br /><br />

            Your Loan Application has been processed by the Bank for
            <strong> {data.Student}</strong>.
            <br /><br />

            With the following details:
            <br />
            <strong>Sponsor:</strong> {data.Sponsor} <br />
            <strong>Student:</strong> {data.Student} <br />
            <strong>Amount Requested / Tenor:</strong> ₦ {formatNumber(data.Amount_Requested) } / {data.Amount_Requested_Tenor * 12} Months  <br />
            <strong className="bg-green-950 text-white">Amount Offered / Tenor:</strong> ₦ {data.Amount_Offered} / {data.Amount_Offered_Tenor * 12} Months  <br />
            <strong>Credit Report:</strong> {data.Credit_Report} <br />
            <strong>Credit Status:</strong> {data.offer_status} <br /><br />

            Congratulations, your application has been approved in principle on
            the condition that you provide all necessary documents to the
            designated Bank.
          </Typography>
          </div>
        </Box>
         }
   
         {
            from !== "loanEv" && 

             <>
               {
                GetOffer !== null &&

                 <>
                 
                   {
                    GetOffer.map(item => (     
                       <>
          <Box sx={{ mb: 4 }}>
          <div>
           <p><b>Applicant ID:</b>{item.SID}</p>
          <Typography variant="body1" sx={{ lineHeight: 1.9,fontFamily:"monospace" }}>
            Dear <strong>{item.Sponsor}</strong>,
            <br /><br />

            Your Loan Application has been processed by the Bank for
            <strong> {item.Student}</strong>.
            <br /><br />

            With the following details:
            <br />
            <strong>Sponsor:</strong> {item.Sponsor} <br />
            <strong>Student:</strong> {item.Student} <br />
            <strong>Amount Requested / Tenor:</strong> ₦ {formatNumber(item.Amount_Requested) } / {item.Amount_Requested_Tenor * 12} Months  <br />
            <strong className="bg-green-950 text-white"> Amount Offered / Tenor:</strong> ₦ {item.Amount_Offered} / {item.Amount_Offered_Tenor * 12} Months  <br />
            <strong>Credit Report:</strong> {item.Credit_Report} <br />
            <strong>Credit Status:</strong> {item.offer_status} <br /><br />

             <span className="text-green-600">Congratulations, your application has been approved in principle on
            the condition that you provide all necessary documents to the
            designated Bank.</span>
          </Typography>
          </div>
           </Box>

             
               {/* ACTION BUTTONS */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          gap: 2,
          mt: 4,
          "@media (max-width:600px)": {
            flexDirection: "column",
            width: "100%",
            px: 2,
          },
          "@media print": { display: "none" },
        }}
      >

          {
            from !== "loanEv" &&
            <>
             {
              disbursementData === null &&
          <p className="font-mono p-4">
          Accept and go to the next page to fill and submit the Utilization Letter.
          </p>
             } 
            </>
          }

           
        <div>

          
          {
            from !== "loanEv" &&
             <>
             
               {
                checkDisburs === "yet"  ?


                    <>
             {
              disbursementData !== null && disbursementData   ?

                 <button
          style={{
            backgroundColor: "gray",
            border: "none",
            padding: "12px",
            color: "white",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: "pointer",
            width: "100%",
          }}
          disabled
        >
          Offer Accepted By You 
        </button>

        :

          <button
          style={{
            backgroundColor: "#4caf50",
            border: "none",
            padding: "12px",
            color: "white",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: "pointer",
            width: "100%",
          }}
           onClick={() => HandleNavigate(item.Sponsor.replace(/\bN\/A\b/g, " ").trim(),item.Amount_Offered)}
        >
          Accept Offer 
        </button>

             }
             
            
            </>

            :

             checkDisburs === "returned_request" ?

              <button
          style={{
            backgroundColor: "darkblue",
            border: "none",
            padding: "12px",
            color: "white",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: "pointer",
            width: "100%",
          }}
           onClick={() => HandleNavigate(item.Sponsor.replace(/\bN\/A\b/g, " ").trim(),item.Amount_Offered)}
        >
          Utilization Letter Returned : Refill the form again according to the needs. 
        </button>

        :

              
                    <>
             {
              disbursementData !== null && disbursementData   ?

                 <button
          style={{
            backgroundColor: "gray",
            border: "none",
            padding: "12px",
            color: "white",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: "pointer",
            width: "100%",
          }}
          disabled
        >
          Offer Accepted By You 
        </button>

        :

          <button
          style={{
            backgroundColor: "#4caf50",
            border: "none",
            padding: "12px",
            color: "white",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: "pointer",
            width: "100%",
          }}
           onClick={() => HandleNavigate(item.Sponsor.replace(/\bN\/A\b/g, " ").trim(),item.Amount_Offered)}
        >
          Accept Offer 
        </button>

             }
             
            
            </>

            
              }
             
             </>
           
      
          }

      






        </div>
     
      </Box>


           </>
           


          ))
                   }
                  </>
     
               }
             </>
         }


      
    

      {/* MOBILE-RESPONSIVE TABLE + PRINT FIXES */}
      <style>
        {`
          /* MOBILE STACKED TABLE */
          @media (max-width: 600px) {
            table, thead, tbody, th, td, tr {
              display: block !important;
              width: 100% !important;
            }

            thead {
              display: none !important;
            }

            tr {
              margin-bottom: 15px;
              border: 1px solid #ccc;
              border-radius: 8px;
              padding: 10px;
              background: #fff;
            }

            td {
              padding: 8px 10px !important;
              position: relative;
              text-align: left !important;
              border: none !important;
              display: flex;
              justify-content: space-between;
              font-size: 14px;
            }

            td:before {
              content: attr(data-label);
              font-weight: bold;
              color: #444;
            }
          }

          /* PRINT FIXES */
          @media print {
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            #print-area {
             
              margin: 0;
            }
            
            .d-btn{
                display: none;
            }
          }
        `}
      </style>

    </Box>
  );
}
